import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, ReplaySubject } from 'rxjs';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResponseCargueI } from 'src/app/modelos/ResponseCargue';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-carguemsuper',
  templateUrl: './carguemsuper.component.html',
  styleUrls: ['./carguemsuper.component.css']
})
export class CarguemsuperComponent implements OnInit, AfterViewInit {

  uploadedFiles : Array<File>;

  btnCargar : Boolean;
  cargar : Boolean;
  btnContinuar : Boolean;
  continuar : Boolean;
  errorcargue : Boolean;

  idFuente : BigInteger;
  idUsuarioCarga : String;
  RolUsuarioCarga : String;

  file: any;
  contenidoDocumento: string;

  RespuestaCargueMasivo: ResponseCargueI = new ResponseCargueI;

  PeriodoActivo : PeriodoReporteI = new PeriodoReporteI;

  ReporPedRefSi : Boolean;
  ReporPedRefNo : Boolean;
  @ViewChild('openmodalperidoact') openmodalperidoact: ElementRef;
  @ViewChild('closemodalperidoact') closemodalperidoact: ElementRef;

  pdfUrl: string = 'assets/Formatos/Guia diligenciamiento_CHV.pdf';
  xlsxUrl: string = 'assets/Formatos/Plantilla CHV Supersolidaria.xlsx';

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService,
    private appService:AppServiceService
  ) { }

  ngOnInit(): void {
    this.desactivarCierreTeclaEsc();
    this.ReporPedRefSi = false;
    this.ReporPedRefNo = false;
    this.btnCargar = true;
    this.cargar = true;
    this.btnContinuar = true;
    this.continuar = false;
    this.errorcargue = false;
    this.api.consultarPeriodoActivoCHV().subscribe(PeriAc=>{
      this.PeriodoActivo = PeriAc;
    });
    this.RolUsuarioCarga = localStorage.getItem('rol');
    this.api.getUsuarioByUsername(localStorage.getItem("usuario")).subscribe(data=>{
      this.idUsuarioCarga = data.id;
    });
  }

  ngAfterViewInit(){
    this.openmodalperidoact.nativeElement.click();
  }

  public uploadFile(event){
    this.btnCargar = false;
    this.file = (event.target as HTMLInputElement).files[0];
    if(this.file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      this.file.type=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      this.file.type=='application/vnd.ms-excel'){
    }else{
      this.toastr.error('Solamente se permiten archivos tipo EXCEL.', 'Error!');
      return;
    }
    let comp = this;
    let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = function () {
          comp.contenidoDocumento = reader.result.toString();
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
          return error;
        };
  }

  public guardarDocumentoSuper(){
    console.log("Realizar cargue de Super solidaria");
    this.btnCargar = true;
    this.api.cargarArchivoCMSuper(this.idUsuarioCarga, this.file, this.contenidoDocumento ).subscribe(
      result => {
        this.RespuestaCargueMasivo = result;
        if(result.estado == "OK"){
          this.btnContinuar = false;
          this.cargar = false;
          this.errorcargue = false;
          this.continuar = true;
          this.toastr.success(result.mensaje,result.estado + '!');
        } else if (result.estado == "ERROR"){
          this.btnCargar = false;
          this.cargar = true;
          this.errorcargue = true;
          this.toastr.error(result.mensaje,result.estado + '!');
        } else if (result.estado == "ADVERT"){
          this.toastr.error(result.mensaje,result.estado + 'Advertencia!');
        }
      }, error => {
        if(error.status == 500){
          this.toastr.error('Interno: informar atención usuario.','Error!');
        } else {
          this.toastr.error('Cargue incorrecto.','Error!');
        }
      }
    );
  }

  siguienteModulo(){
    this.router.navigate(['consultareporte']);
  }

  download(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById("ErroresCargue"));
    XLSX.utils.book_append_sheet(workbook, ws1, "ErroresCargue");
    XLSX.writeFile(workbook, "Errores_Cargue_Supersolidaria.xlsx");
    this.ngOnInit();
  }

  IrNovedades(){
    let FechaHoy = new Date()
    let HoyDia = FechaHoy.getDate();
    let HoyMes = FechaHoy.getMonth()+1;
    let HoyAnio = FechaHoy.getFullYear();
    let VerificarRecoleccionInicio = this.PeriodoActivo.fechaInicioRecoleccionSuper.split("/");
    let VerificarRecoleccionFin = this.PeriodoActivo.fechaFinRecoleccionSuper.split("/");
    if(this.ReporPedRefSi == true && this.ReporPedRefNo == false){
      if (HoyAnio == +VerificarRecoleccionFin[2]){
        if(HoyMes >= +VerificarRecoleccionInicio[1] && HoyMes <= +VerificarRecoleccionFin[1]){
          if(HoyMes == +VerificarRecoleccionInicio[1] && HoyDia >= +VerificarRecoleccionInicio[0]){
            this.toastr.success('Puede realizar el cargue.','OK!');
            this.closemodalperidoact.nativeElement.click();
          }else if(HoyMes == +VerificarRecoleccionFin[1] && HoyDia <= +VerificarRecoleccionFin[0]){
            this.toastr.success('Puede realizar el cargue.','OK!');
            this.closemodalperidoact.nativeElement.click();
          }else{
            this.toastr.error('Reporte fuera de calendario. Fecha limite : '+this.PeriodoActivo.fechaFinRecoleccionSuper ,'Error!');
          }
        }else{
          this.toastr.error('Reporte fuera de calendario. Fecha limite : '+this.PeriodoActivo.fechaFinRecoleccionSuper ,'Error!');
        }
      }else{
        this.toastr.error('Reporte fuera de calendario. Fecha limite : '+this.PeriodoActivo.fechaFinRecoleccionSuper ,'Error!');
      }
    } else if(this.ReporPedRefSi == false && this.ReporPedRefNo == true){
      this.closemodalperidoact.nativeElement.click();
      this.router.navigate(['consultareporte']);
    } else if (this.ReporPedRefSi == true && this.ReporPedRefNo == true){
      this.toastr.warning('Seleccione solo una opción.','Advertencia!');
      //this.router.navigate(['carguemasivosuper']);
    } else if (this.ReporPedRefSi == false && this.ReporPedRefNo == false){
      this.toastr.warning('Seleccione una opción.','Advertencia!');
      //this.router.navigate(['carguemasivosuper']);
    }
  }

  private desactivarCierreTeclaEsc() {
    const modalElement = document.getElementById('modal-confirma');
    if (modalElement) {
      modalElement.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  exportarExcel(idTabla:string){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById(idTabla));
    XLSX.utils.book_append_sheet(workbook, ws1, idTabla);
    XLSX.writeFile(workbook, idTabla+".xlsx");
  }

}
